import React, {lazy, Suspense} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import moment from 'moment-jalaali';
import HomePage from './components/home';
import ContactUsPage from './components/contact-us';
import AboutUsPage from './components/about-us';
import ComplaintsRegistrationPage from './components/complaints-registration';
import TermsAndConditionsPage from './components/terms-and-conditions';
import LoginPage from './components/login';
import RegisterPage from './components/register';
import ForgetPasswordPage from './components/forget-password';
import ProfilePage from './components/profile';
import HomeworksPage from './components/homeworks';
import ReportPage from './components/report';
import ExamReportPage from './components/exam-report';
import ReportsPage from './components/reports';
import ExamReportsPage from './components/exam-reports';
import StudentCoursesPage from './components/student-courses';
import ConsultPackagesPage from './components/consult-packages';
import PaymentVerify from './components/payment-verify';
import VoicesPage from './components/voices';
import Loader from './components/shared/loader';

const ChartsPage = lazy(function () {
  return import('./components/charts');
});
const ErrorBoundary = lazy(function () {
  return import('./components/shared/error-boundary');
});

function App() {
  return (
    <Router basename={process.env.REACT_APP_BASE_URL}>
      <Suspense fallback={<Loader/>}>
        <ErrorBoundary>
          <Switch>
            <Route exact path='/' component={HomePage}/>
            <Route exact path='/contact-us' component={ContactUsPage}/>
            <Route exact path='/about-us' component={AboutUsPage}/>
            <Route exact path='/complaints-registration' component={ComplaintsRegistrationPage}/>
            <Route exact path='/terms-and-conditions' component={TermsAndConditionsPage}/>
            <Route exact path='/login' component={LoginPage}/>
            <Route exact path='/register' component={RegisterPage}/>
            <Route exact path='/forget-password' component={ForgetPasswordPage}/>

            <Route exact path='/profile/:item?' component={ProfilePage}/>
            <Route exact path='/homeworks/:scId?' component={HomeworksPage}/>
            <Route exact path='/report/:scId?' component={ReportPage}/>
            <Route exact path='/reports/:scId?' component={ReportsPage}/>
            <Route exact path='/exam-report' component={ExamReportPage}/>
            <Route exact path='/exam-reports' component={ExamReportsPage}/>
            <Route exact path='/student-courses' component={StudentCoursesPage}/>
            <Route path='/charts' component={ChartsPage}/>
            <Route exact path='/voices/:scId?' component={VoicesPage}/>

            <Route exact path='/consult-packages' component={ConsultPackagesPage}/>
            <Route exact path='/payments/:paymentId/verify' component={PaymentVerify}/>
          </Switch>
        </ErrorBoundary>
      </Suspense>
    </Router>
  );
}

moment.loadPersian({usePersianDigits: false, dialect: 'persian-modern'});

export default App;
